import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { RedirectError } from '#src/shared/error';

import { useCampaignActionsEnabled } from '../useCampaignActionsEnabled';

/**
 * This hook runs logic that needs to happen on first view.
 */
export const useInitialize = (): void => {
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	const campaignActionsEnabled: boolean = useCampaignActionsEnabled();
	if (!campaignActionsEnabled) {
		throw new RedirectError({ url: `/p/${encodeURIComponent(slug)}`, forwardQueryParams: true });
	}
};
